// @flow

const SELECTOR =
  'button:not([tabindex="-1"]), [href]:not([tabindex="-1"]), input:not([tabindex="-1"]), select:not([tabindex="-1"]), textarea:not([tabindex="-1"]), [tabindex]:not([tabindex="-1"])';
const DISABLED = 'tabindex-disabled';

export const removeTabindex = (parentElementId: string) => {
  const el = document.getElementById(parentElementId);
  if (el) {
    const focusable = el.querySelectorAll(SELECTOR);
    Array.prototype.forEach.call(focusable, el => {
      el.classList.add(DISABLED);
      el.setAttribute('tabindex', -1);
    });
  }
};

export const restoreTabIndex = () => {
  const disabled = document.getElementsByClassName(DISABLED);
  Array.prototype.forEach.call(disabled, el => {
    el.classList.remove(DISABLED);
    el.setAttribute('tabindex', 0);
  });
};
